<script setup lang="ts">
import { computed } from 'vue'
import type { IInputFieldEvents, IInputFieldProps } from '../types'
import { PInput } from '../parts'
import useInputLogic from '@/ui/plushComponents/VInputField/composables/useInputLogic'
import { EStates } from '@/ui/composables/useCreateComponentConfig'

const props = defineProps<IInputFieldProps<'search-simple'>>()
const emit = defineEmits<IInputFieldEvents>()

const options = computed(() => props.options)
const readOnly = computed(() => options.value.state === EStates.READ_ONLY)
const disabled = computed(() => options.value.state === EStates.DISABLED)

const { isError, debouncedUpdateModelValue, handleBlur, handleClear, handleFocus } = useInputLogic(props, emit)

const trailingIcon = computed<string | false>(() =>
    props.modelValue.length >= 3 && !disabled.value && !readOnly.value ? 'close' : false,
)
</script>

<template>
    <div class="grow-1 flex max-w-[480px] flex-col">
        <PInput
            v-bind="options"
            :model-value="props.modelValue"
            :aria="{
                label: options.aria?.label || options.name || 'Input',
            }"
            :placeholder="options.placeholder || 'Wyszukaj'"
            leading-icon="search"
            :trailing-icon="trailingIcon"
            :is-error="isError"
            :data-test="props.dataTest"
            :auto-complete="options.autoComplete ?? 'autocomplete'"
            :auto-focus="options.autoFocus ?? false"
            @update:model-value="debouncedUpdateModelValue"
            @clear="handleClear"
            @blur="handleBlur"
            @focus="handleFocus"
        />
        <HelperMessage
            v-if="options.helper"
            class="mt-2xs"
            size="SMALL"
            :message="options.helper"
        />
    </div>
</template>
